export default __webpack_public_path__ + "static/media/btn_edit_user_gray.1dd55df6.svg";